import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';
import { sendClick } from 'reaxl-analytics';
import { walletAutoSyncSuccess } from 'reaxl-analytics-handlers';
import { WALLET_CREATE_ID_REQUEST, WALLET_CREATE_ID_COMPLETED } from 'wallet-manager';
const useWalletSyncInitialization = _ref => {
  let {
    paymentsDuck
  } = _ref;
  const dispatch = useDispatch();
  const isPaymentsInfoLoaded = useSelector(paymentsDuck.selectors.getIsPaymentsInfoLoaded);
  const syncAlert = useSelector(state => paymentsDuck.selectors.getMyWalletInteraction(state, 'syncAlert'));
  const walletId = useSelector(paymentsDuck?.selectors?.getWalletId);
  const displayModal = useSelector(paymentsDuck.selectors.getDisplayMyWalletModal);
  const isAutoSync = syncAlert?.isAuto;
  useEffect(() => {
    if (isAutoSync) {
      sendClick(walletAutoSyncSuccess, {});

      // set the flag back to false so the event wouldn't fire on refresh
      dispatch(paymentsDuck.creators.updateMyWalletInteractions({
        syncAlert: {
          ...syncAlert,
          isAuto: false
        }
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoSync]);
  useEffect(() => {
    if (displayModal && isPaymentsInfoLoaded && !walletId) {
      // attempt to create id when modal is open
      eventBus.emit(WALLET_CREATE_ID_REQUEST);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayModal, isPaymentsInfoLoaded]);
  function updateWalletId() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (data.length) {
      dispatch(paymentsDuck.creators.setWalletId(data));
    }
  }
  useEffect(() => {
    eventBus.on(WALLET_CREATE_ID_COMPLETED, updateWalletId);
    return () => {
      eventBus.off(WALLET_CREATE_ID_COMPLETED, updateWalletId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
export { useWalletSyncInitialization as default };
